$(document).ready(function() {
    if ($('.product-header').length) {
        $('.product-header').find('h1.product-info__title').html('Miracle 2000<sup>®</sup> GOLD');
        console.log('Product title successfully updated using jQuery.');
    } else {
        console.warn('.product-header element not found.');
    }


    const $productForm = $('.pf-product-form');

    if ($productForm.length) {
      
      const $addToCartButton = $productForm.find('.js-product-add-to-cart-button');

      if ($addToCartButton.length) {

          $addToCartButton.on('click', function(e) {
              
              const $cartLink = $('.js-drawer-open-right');
        
              if ($cartLink.length) {
                  
                setTimeout(function() {
                  $cartLink[0].click(); 
                  console.log('Cart drawer click successfully executed.');
                }, 500);  
                  
              } else {

                  console.warn('Cart link element (.js-drawer-open-right) not found to trigger the click.');

              }
          });

      } else {

          console.warn('Add to Cart button (.js-product-add-to-cart-button) not found inside the form.');

      }
      
    }  
    else {

        console.warn('Shopify product form not found. Check the ID is correct.');

    }


    // $(document.body).on('ajaxCart.afterAdd', function(e, cart, item) {
        
    //     alert('card called');
        
    //     const $cartLink = $('.js-drawer-open-right');
        
    //     if ($cartLink.length) {

    //         alert('cart opened');
            
    //         $cartLink[0].click(); 
    //         console.log('Cart drawer click successfully executed.');
            
    //     } else {

    //         console.warn('Cart link element (.js-drawer-open-right) not found to trigger the click.');

    //     }
    // });

});

(function($){
  // === EDIT these to match your theme ===
  var CART_COUNT_SELECTOR = '.js-cart-count';   // header count element used by your theme
  var CART_CONTAINER      = '#CartContainer';   // the mini-cart DOM container (if exists)

  function openMiniCart(){
    // Theme uses .cart__hover.active_cart to open
    $('.cart__hover').addClass('active_cart');
    setTimeout(function(){ $('.active_cart').removeClass('active_cart'); }, 5000);
  }

  function updateHeaderCount(cart){
    if (!cart) return;
    var $count = $(CART_COUNT_SELECTOR);
    if ($count.length){
      $count.html(cart.item_count).removeClass('hidden-count');
      if (cart.item_count === 0) $count.addClass('hidden-count');
    }
  }

  function rebuildMiniCart(cart){
    // If the theme's ajaxCart is present, let it rebuild templated mini-cart
    if (window.ajaxCart && typeof ajaxCart.load === 'function'){
      ajaxCart.load();
      return;
    }
    // Fallback: still show the drawer so the user sees the update
    openMiniCart();
  }

  function refreshCartUI(){
    if (window.ShopifyAPI && typeof ShopifyAPI.getCart === 'function'){
      ShopifyAPI.getCart(function(cart){
        updateHeaderCount(cart);
        rebuildMiniCart(cart);
        openMiniCart();
      });
    } else {
      // Worst-case fallback
      openMiniCart();
    }
  }

  // ---- Hook 1: If you control the Add to Cart success, call refreshCartUI() there.
  // But to be resilient, also listen to theme events and PageFly clicks:

  // Theme convention events (your theme triggers these in addItemFromForm)
  $(document.body).on('afterAddItem.ajaxCart', function(){
    refreshCartUI();
  });

  // Generic hook: if your custom button posts to /cart/add.js,
  // intercept the success path by monkey-patching $.ajax for that endpoint.
  var _oldAjax = $.ajax;
  $.ajax = function(opt){
    var isCartAdd = opt && /\/cart\/add\.js/.test(opt.url || '');
    if (isCartAdd){
      var userSuccess = opt.success;
      opt.success = function(){
        try { if (typeof userSuccess === 'function') userSuccess.apply(this, arguments); }
        finally { refreshCartUI(); }
      };
    }
    return _oldAjax.apply($, arguments);
  };

  // If your PageFly button is a normal form, also catch submit success via DOM:
  // (No-op if not present)
  $(document).on('click', '.js-product-add-to-cart-button', function(){
    // Small delay to wait for /cart/add.js to complete if it’s async
    setTimeout(refreshCartUI, 1200);
  });

})(jQuery);

(function($){
  document.addEventListener('DOMContentLoaded', function(){
    if (window.ajaxCart && typeof ajaxCart.init === 'function') {
      ajaxCart.init({
        formSelector: '.pf-product-form',             // your PageFly form
        cartContainer: '#cart-popup',           // the mini-cart container
        addToCartSelector: 'button[type="submit"], input[type="submit"]',
        cartCountSelector: '.CartCount',       // <-- make sure this matches your header count element
        cartCostSelector:  '.js-cart-cost',
        isProduct: true
      });
    }
  });
})(jQuery);


$(document).on('click', '.AOV-CartDrawer-Close', function(){
  $('body').removeClass('js-drawer-open-right');
});




// $(document).on('click', '.js-drawer-open-right', function(){
  
//   $('body').addClass('js-drawer-open-rights');
//   $('.AOV-CartDrawer-Overlay').css({
//         "display": "block",
//         "opacity": "1"
//     });
// });
